<template>
	<form @submit.prevent="save">
		<vs-card class="flex flex-col justify-between p-5" fixedHeight style="min-height: 70vh">
			<ResponseAlert ref="response" />			
			<vs-row class="pt-5">
				<div class="w-full md:w-1/2 md:px-3">
					<div class="w-full mb-5">
						<vs-input 
								autocomplete="off"
								v-validate="'required'" 
								label="Name" 
								name="name" 
								type="text"
								v-model="models.name" 
								class="w-full"/>
						<span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span>
					</div>
					<div class="w-full my-5">
						<label class="pl-2 text-sm" for="status">Status</label>
						<ul id="status" class="flex mt-3">
							<li>
								<vs-radio v-model="models.isActive" vs-name="status" :vs-value="true" class="mr-5">Active</vs-radio>
							</li>
							<li>
								<vs-radio v-model="models.isActive" vs-name="status" :vs-value="false">Inactive</vs-radio>
							</li>
						</ul>
						<span class="text-danger text-sm" v-show="errors.has('status')">{{ errors.first('status') }}</span>
					</div>
				</div>
				<div class="w-full md:w-1/2 md:pl-3">
					<div class="w-full mb-5 mt-5 md:mt-0">
						<label for="menus">Select Menu</label>
						<ul class="mt-4">
							<li v-for="menu in masters.menus" :key="menu.id" class="mb-3">
								<label>
									<input @change="toggleParent(menu)" type="checkbox" v-model="models.menuIds" :value="menu.id">
									<span class="ml-2 -mt-1">{{menu.name}}</span>
								</label>
								<ul v-if="menu.children" class="mt-3">
									<li v-for="child in menu.children" :key="child.id" class="mb-3 pl-6">
										<label>
											<input @change="toggleChildren(menu)" type="checkbox" v-model="models.menuIds" :value="child.id">
											<span class="ml-2 -mt-1">{{child.name}}</span>
										</label>
									</li>
								</ul>
							</li>
						</ul>
					</div>
				</div>
			</vs-row>

			<div slot="footer" class="justify-center">
				<vs-button button="submit" color="primary" type="filled" class="mr-3">Save</vs-button>
				<vs-button @click="$router.go(-1)" color="rgb(172,172,172)" type="border">Cancel</vs-button>
			</div>
		</vs-card>
	</form>
</template>

<script>
	import api from '@/utils/api.js'

	export default {
		name: 'FormUser',
		data() {
			return {
				config: {
					uri: this.$route.meta.link,
				},
				models: {
					name: "",
					isActive: true,
					menuIds: []
				},
				masters: {
					menus: [
					]
				},
			}
		},
		created() {
			this.getById();
			this.getMenus()
		},
		methods: {
			getById() {
				if (this.$route.params.id) {
					this.$axios.get(`${api.roles}/${this.$route.params.id}`)
						.then(res => {
							const { data } = res.data;
							this.models.name = data.name;
							this.models.isActive = data.isActive;
							this.models.menuIds = data.menus.map(menu => menu.id);
						}).catch(() => this.$router.push({
							name: 'page404'
						}));
				}
			},
			getMenus() {
				this.$axios.get(api.menus).then(res => {
					const {data} = res.data
					data.forEach(parent => {
						if(parent.children.length !== 0) {
							const children = []
							parent.children.forEach(child => {
								children.push({
									id: child.id,
									name: child.name
								})
							})

							this.masters.menus.push({
								id: parent.id,
								name: parent.name,
								children
							})
						} else {
							if(!parent.parentId) {
								this.masters.menus.push({
									id: parent.id,
									name: parent.name
								})
							}
						}
					})
				});
			},
			toggleParent(menu){
				if(menu.children){
					const childrenIds =	menu.children.map(c => c.id)
					this.models.menuIds = this.models.menuIds.includes(menu.id) ? 
						[...this.models.menuIds, ...childrenIds] :
						this.models.menuIds.filter(menu => !childrenIds.includes(menu))
				}
			},
			toggleChildren(menu){
				if(menu.children) {
					if(!this.models.menuIds.includes(menu.id)){
						this.models.menuIds.push(menu.id)
					}else {
						const childrenIds =	menu.children.map(c => c.id)
						const child = this.models.menuIds.filter(child => childrenIds.includes(child))

						if(child.length === 0) {
							this.models.menuIds = this.models.menuIds.filter(m => m !== menu.id)
						}
					}
				}
			},
			save() {
				this.$validator.validate().then(valid => {
					if (valid) {
						let request = "";
						let message = "create"
						if (!this.$route.params.id) {
							request = this.$axios.post(api.roles, this.models);
						} else {
							message = "update"
							request = this.$axios.put(`${api.roles}/${this.$route.params.id}`, this.models);
						}
						request
							.then(() => {
								this.$showToast('Success', `Success ${message} role`,)
								this.$router.push({
									name: this.config.uri
								})
							})
							.catch(error => this.$refs.response.setResponse(error.response.data, 'danger'));
					} else {
						window.scrollTo(0, 0);
					}
				});
			}
		}
	}
</script>